import { module } from 'angular';
import { baseModuleId } from '../common/constants/base-module-id';
import { ProductBulletsDirective } from './product-bullets.directive';
export var ProductBulletsComponentNgModule = module(baseModuleId + ".product-bullets", [])
    .directive('productBullets', ProductBulletsDirective);
